import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Poster - Visual explanations"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Poster`}</h3>
    <h1>{`Visual Explanations`}</h1>
    <p>{`The visual representation of a phenomenon is always mediated by its translations into data. As designers, we often focus on translating data into something visual, but how was that data produced?`}</p>
    <p>{`Statistical methods are used to translate phenomena into data, making them analyzable — at known prices: each method has strengths and weaknesses.
Datasets are the result of a design process, and therefore is fundamental for designers to have an idea of the processes used to produce them.`}</p>
    <p>{`During the first month of the course, students studied eight algorithmic statistical methods to produce a poster visually explaining how they work, third strength and weaknesses.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      